// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../style.css\"","easilGrayXXLight":"#F9F9FA","easilBlack":"#2c2e2f","option":"style_option__LqiNB","selected":"style_selected__30wp3","name":"style_name__2T_RL"};